<div class="ga-draw-buttons">
  @for (tool of drawTools; track tool) {
    <button
      (click)="chooseDrawTool(tool.id)"
      title="{{ tool.name }}"
      class="draw_tool_button {{ tool.iconClass }}"
      [class.hidden-mobile]="tool.hideMobile"
      [class.highlight]="tool.id === activeTab">
      <div class="draw_tool_text">{{ tool.name }}</div>
    </button>
  }
</div>

@if (!is3dActive()) {
  <div class="ga-draw-modify">
    <div class="flex-wrapper">
      @if (!(chosenTool === 'Delete' || chosenTool === 'Modify' || chosenTool === 'None')) {
        <div class="flex-item hidden-mobile">
          <label>
            Farge:
            <select class="form-control" #selClr (change)="chooseColor(selClr.value)">
              @for (c of colors; track c) {
                <option [value]="c.value" [selected]="c === optionColor">
                  {{ c.name }}
                </option>
              }
            </select>
          </label>
        </div>
      }
      @if (chosenTool === 'Text') {
        <div class="flex-item text-field">
          <label>
            Tekst:
            <input
              class="textInput"
              [(ngModel)]="optionText"
              placeholder="Legg til tekst"
              (ngModelChange)="changeText()"
              type="text" />
          </label>
        </div>
      }
      @if (chosenTool === 'Point') {
        <div class="flex-item hidden-mobile">
          <label>
            Størrelse:
            <select class="form-control" [(ngModel)]="optionSymbolSize" (change)="chooseSize()">
              @for (s of pointSizes; track s) {
                <option [ngValue]="s.scale" [selected]="s.scale === optionSymbolSize">
                  {{ s.label }}
                </option>
              }
            </select>
          </label>
        </div>
      }
      @if (chosenTool === 'Point') {
        <div class="symbols hidden-mobile">
          <label>Symbol:</label>
          <div class="ga-choose-icon">
            @for (item of pointSymbols; track item; let i = $index) {
              <span (click)="chooseIcon(i)" [ngClass]="[item.class, optionColor.value]">
                {{ item.id }}
              </span>
            }
          </div>
        </div>
      }
      @if (chosenTool === 'LineString' || chosenTool === 'Polygon') {
        <div class="flex-item hidden-mobile">
          <label>
            Bredde:
            <select class="form-control" #lw (change)="chooseLinewidth(lw.value)">
              @for (line of strokeWidths; track line) {
                <option [value]="line.value" [selected]="line.value === optionStrokeWidth">
                  {{ line.label }}
                </option>
              }
            </select>
          </label>
        </div>
      }
      @if (chosenTool === 'LineString' || chosenTool === 'Polygon') {
        @if (chosenTool === 'Polygon' || chosenTool === 'LineString') {
          <div class="symbols flex-item">
            <label class="checkbox">
              <input
                #measureCheckBox
                id="measureCheckBox"
                type="checkbox"
                [checked]="showMeasurement"
                (change)="changeShowMeasurement()" />
              @if (chosenTool === 'Polygon') {
                <span> Vis areal i kartet</span>
              }
              @if (chosenTool === 'LineString') {
                <span> Vis lengde i kartet</span>
              }
            </label>
          </div>
        }
        @if (chosenTool === 'Polygon') {
          <div class="symbols flex-item">
            <label class="checkbox">
              <input
                #useFillColorRef
                id="polygonFillCheckBox"
                type="checkbox"
                [checked]="optionUseFill"
                (change)="changeUseFillColor(useFillColorRef.checked)" />
              Fyll med farge
            </label>
          </div>
        }
      }
    </div>
    <div class="tips hidden-mobile">
      @if (activeTab === 'Polygon' || activeTab === 'LineString') {
        <div>
          <strong>Tips:</strong><br />
          Dobbeltklikk for å fullføre tegning. Trykk <span class="keyboard-key">esc</span> for å angre siste tegnesteg.
          Hold <span class="keyboard-key">shift</span> for å tegne frihånd.
        </div>
      }
      @if (activeTab === 'Modify') {
        @if (chosenTool === 'Modify') {
          <div>
            Velg et objekt for å endre farge, linjetykkelse, symbol og tekst.<br />
            <br />
          </div>
        }
        @if (chosenTool === 'Point' || chosenTool === 'Text') {
          <div>
            <strong>Tips:</strong><br />
            Klikk og dra objektet for å flytte det i kartet
          </div>
        }
        @if (chosenTool === 'LineString' || chosenTool === 'Polygon') {
          <div>
            <strong>Tips:</strong><br />
            Dra blått punkt for å endre form på linje/flate.<br />
            Hold nede <span class="keyboard-key">alt</span> og trykk for å fjerne knekkpunkt.<br />
            Hold <span class="keyboard-key">shift</span> for å flytte hele objektet.
          </div>
        }
      }
      @if (activeTab === 'Delete') {
        <div>
          Velg objekt og trykk «Slett valgt(e)».<br />
          Hold <span class="keyboard-key">shift</span> for å markere flere.
        </div>
      }
    </div>
    @if (activeTab === 'Delete') {
      <div class="flex-wrapper buttons">
        <button mat-button class="deleteButton flex-item" (click)="deleteAllFeatures()">
          <span>Slett alle objekter</span>
        </button>
        <button mat-button class="deleteButton flex-item" (click)="deleteFeatures()">
          <span
            >Slett {{ nrSelectedFeatures === 0 ? '' : nrSelectedFeatures }} valgt{{ nrSelectedFeatures > 1 ? 'e' : '' }}
          </span>
        </button>
      </div>
    }
  </div>
}

@if (is3dActive()) {
  <div class="ga-draw-modify">Tegning er ikke tilgjengelig i 3D-modus. Gå til 2D-visning for å tegne.</div>
}
